import { ReactNode } from 'react';
import styles from './ButtonGroup.module.scss';

interface Props {
  children: ReactNode;
  align?: 'center' | 'end' | 'start';
  direction?: 'column' | 'row';
  width?: 'full' | 'auto';
}

export function ButtonGroup(props: Props) {
  const { align = 'center', direction = 'row' } = props;
  const className = [
    styles['button-group'],
    styles['button-group-align-' + align],
  ]
    .filter(Boolean)
    .join(' ');
  const contentClassName = [
    styles['button-group-content'],
    styles['button-group-content-direction-' + direction],
    props.width === 'full' && styles['full-width'],
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className}>
      <div className={contentClassName}>{props.children}</div>
    </div>
  );
}
